import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-load-watch-dashboard-layout',
  templateUrl: './load-watch-dashboard-layout.component.html',
  styleUrls: ['./load-watch-dashboard-layout.component.css', './../../../fleetdiag-dashboard-pro/fleetdiag-dashboard-pro.component.scss']
})
export class LoadWatchDashboardLayoutComponent implements OnInit  {
  menuItems = [
    { label: 'داشبورد کلی', route: 'all', icon: 'fa-home' },
    { label: 'شاخص ها', route: 'indicators', icon: 'fa-bar-chart' },
    { label: 'تحلیل دوره ای', route: 'periodic-analysis', icon: 'fa-line-chart' },
    { label: 'عملکرد', route: 'performance', icon: 'fa-tachometer' },
    { label: 'سلامت ژنراتور ', route: 'generator-health', icon: 'fa-heartbeat' },
  ];


  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  goBack() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

}